export default angular
  .module('st.Integrations.Outlook', [])
  .service('outlookService', ($http, $rootScope, dataService, Note, OUTLOOK) => ({
    authenticate: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, OUTLOOK.API.AUTHENTICATE, {
        params
      }),
    authenticated: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, OUTLOOK.API.AUTHENTICATED, {
        params
      }),
    deauthenticate: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, OUTLOOK.API.DE_AUTHENTICATE, {
        params
      }),
    getAvailablePerContact: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        Note.build,
        $http.post,
        OUTLOOK.API.GET_AVAILABLE_PER_CONTACT,
        params
      ),
    isEnabled: (account) => _.get(account, 'integrations.outlookMail.enabled')
  }))
  .constant('OUTLOOK', {
    API: {
      AUTHENTICATE: '/api/v1/integration/outlook/authenticate',
      AUTHENTICATED: '/api/v1/integration/outlook/authenticated',
      DE_AUTHENTICATE: '/api/v1/integration/outlook/deauthenticate',
      GET_AVAILABLE_PER_CONTACT: '/api/v1/integration/outlook/get-available-per-contact'
    }
  });
